"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionTarget = exports.PromotionRateType = exports.PromotionType = void 0;
var api_service_1 = require("./api-service");
var PromotionService = /** @class */ (function (_super) {
    __extends(PromotionService, _super);
    function PromotionService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.endpoint = 'promotions/promotions';
        return _this;
    }
    PromotionService.prototype.promotions = function (params) {
        return this.getCollectionRequest(this.url(), {
            params: params,
        });
    };
    PromotionService.prototype.createPromotion = function (promotion) {
        return this.postRequest(this.url(), promotion);
    };
    PromotionService.prototype.getPromotion = function (id) {
        return this.getRequest(this.url(id));
    };
    PromotionService.prototype.updatePromotion = function (id, data) {
        return this.putRequest(this.url(id), data);
    };
    PromotionService.prototype.deletePromotion = function (id) {
        return this.deleteRequest(this.url(id));
    };
    return PromotionService;
}(api_service_1.ApiService));
exports.default = PromotionService;
var PromotionType;
(function (PromotionType) {
    PromotionType["CATALOG"] = "catalog";
    PromotionType["COUPON"] = "coupon";
})(PromotionType = exports.PromotionType || (exports.PromotionType = {}));
var PromotionRateType;
(function (PromotionRateType) {
    PromotionRateType["DISTRIBUTED"] = "distributed";
    PromotionRateType["FIXED"] = "fixed";
    PromotionRateType["PERCENTAGE"] = "percentage";
})(PromotionRateType = exports.PromotionRateType || (exports.PromotionRateType = {}));
var PromotionTarget;
(function (PromotionTarget) {
    PromotionTarget["ITEMS"] = "items";
    PromotionTarget["SHIPPING"] = "shipping";
})(PromotionTarget = exports.PromotionTarget || (exports.PromotionTarget = {}));
//# sourceMappingURL=promotion-service.js.map